import { registerSW } from 'virtual:pwa-register';
import { createApp } from 'vue';
import { initErrorTracker, loadFont, setPalette } from '@/utility';
import { initGTM, terminalPlugin } from '@/plugins';
import { TopPositionDirective } from '@/directives';
import integrator from '@/services/integrator';
import AppTransition from '@/components/common/AppTransition.vue';
import config from '../config';
import App from './App.vue';
import router from './router';
import store from './store';
import './polyfills';
import '@/styles/main.scss';
import { logger, eventBus } from '@/utility';
import constants from '@/utility/constants';

const updateSW = registerSW({
  onNeedRefresh() {
    logger.info('[7CC] onNeedRefresh');

    eventBus.subscribe(constants.BUS_MESSAGES.REFRESH_CONFIRMED, async () => {
      const selfReload =
        config.integration.type === constants.INTEGRATOR_TYPES.GRAVITY_GATEWAY ||
        !config.integration.active;
      await updateSW?.(selfReload);

      if (!selfReload) {
        integrator?.requestReload();
      }
    });

    eventBus.publish(constants.BUS_MESSAGES.REFRESH_NEEDED);
  },
});

const app = createApp(App);

app.component('AppTransition', AppTransition);
app.directive('top-position', TopPositionDirective);

const setupApp = async () => {
  await store.dispatch('loadApplicationSettings');
  const { palette, font, GTMCode } = store.state.applicationSettings;

  if (GTMCode) initGTM(app, GTMCode);
  setPalette(palette);
  loadFont(font);
};

const startApp = async () => {
  if (config.errorTracker.active) initErrorTracker(app, router);

  await setupApp();

  if (config.integration.active) {
    const message = await integrator.init(config.integration);

    await store.dispatch('setInitialAppData', message);
  } else {
    // for app to work in non integration mode
    await store.dispatch('setInitialAppData');
  }

  await store.dispatch('loadInitialData');

  if (store.getters.isTerminalChannelActive) app.use(terminalPlugin);
  app.use(router).use(store).mount('#app');

  if (config.useMemoryHistory) {
    const path = window.location.href.replace(window.location.origin, '');

    await router.push({ path, replace: true });
  }
};

startApp();
